/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCirclesRelation = createReactComponent("outline", "circles-relation", "IconCirclesRelation", [["path", { "d": "M9.183 6.117a6 6 0 1 0 4.511 3.986", "key": "svg-0" }], ["path", { "d": "M14.813 17.883a6 6 0 1 0 -4.496 -3.954", "key": "svg-1" }]]);

export { IconCirclesRelation as default };
//# sourceMappingURL=IconCirclesRelation.mjs.map
